import { NotificationsActions } from './actions'
import { NotificationsGetters } from './getters'
import { NotificationsMutations } from './mutations'
import { NotificationsState } from './state'

export const NOTIFICATION_NAMESPACE = 'notification'

export const Notifications = {
  namespaced: true,
  state: NotificationsState,
  actions: NotificationsActions,
  getters: NotificationsGetters,
  mutations: NotificationsMutations,
}
